import Vue from 'vue'
import Router from 'vue-router'

import auth from '../auth'

import Faq from '@/pages/Faq'
import Overview from '@/pages/Overview'
import Disclaimer from '@/pages/Disclaimer'
import Trajectory from '@/pages/Trajectory'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/faq', name: 'faq', component: Faq },
    { path: '/trajectory', name: 'trajectory', component: Trajectory },
    { path: '/disclaimer', name: 'disclaimer', component: Disclaimer },
    { path: '*', name: 'home', component: Overview }
  ]
})

router.beforeEach((to, from, next) => {
  auth.isAuthenticated() ? next() : auth.signIn()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js